<template>
  <Content id="users">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="名称"><Input v-model="search.name" maxlength="50"/></FormItem></Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="name" label="名称" show-overflow-tooltip  min-width="100"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="150" id="elPopoverVisible">
        <template slot-scope="{row}"><el-button type="text" size="medium" @click="handleEdit(row)">编辑</el-button></template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal ref="modalRef" v-model="editWindow" width="25%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <ReferraDepartmentEdit ref="edit" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}" @on-submit="handleSubmit" />
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {_pages, _updateStatus} from "@/services/screeningConfig/referralDepartment.js";
import ReferraDepartmentEdit from "./ReferraDepartmentEdit";
export default {
  name: "ReferraDepartment",
  components: {
    ReferraDepartmentEdit
  },
  computed: {

  },
  data() {
    return {
      search: {
        name:"",
        status:1
      },
      maxHeight: 0,
      tableHeight: 0,
      currentRowIndex: null,
      editWindow:false,
      windowTitle:"新增转诊科室",
      deleteVisible:{},
      dataList: [],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0,
      },
      statusList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  async mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _pages({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode == 1){
          this.dataList = res.data.records;
          this.pageList.total = res.data.total;
        } else {
          this.$message.error(res.errmsg)
        }
      }).catch(() => {});
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();

      this.$nextTick(() => {
        const height = this.$refs["modalRef"].innerHeight || document.documentElement.clientHeight;
        this.maxHeight = `${height - 250}px`;
      });
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);

      this.$nextTick(() => {
        const height = this.$refs["modalRef"].innerHeight || document.documentElement.clientHeight;
        this.maxHeight = `${height - 250}px`;
      });
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}

</style>
